/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { apiClient } from '@lib/api-client';
import { TMutationConfig } from '@lib/react-query';
import { useMutation } from '@tanstack/react-query';

// Components
import { notifications } from '@mantine/notifications';

// Types
import { IApiError, TUser } from '@global-types/index';

// I18n
import { useTranslation } from 'react-i18next';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */

export const enableUser = (
	id: string
): Promise<TUser> => {
	return apiClient.patch(`/users/${id}/enable`);
};

export const useEnableUser = ({
	mutationConfig,
}: {
	mutationConfig?: TMutationConfig<typeof enableUser>;
}) => {
	const { onSuccess } = mutationConfig || {};

	const { t } = useTranslation();
	const { mutate, isPending: isLoading } = useMutation({
		mutationFn: enableUser,
		onSuccess: (...args) => {
			onSuccess?.(...args);
		},
		onError: (error: IApiError) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'var(--mantine-color-igluRed-9)',
			});
		},
	});

	return { mutate, isLoading };
};
